import type * as ents from '@attain-apps/entities'
import type * as ds from '@attain-apps/fe/web/main/lib/design'

export interface Node
  extends ents.core.common.Identified<Node.Id>,
    ents.core.common.Named {
  type: 'default' | 'temporary' | 'future'
  person?: string
  purpose?: string
  notes?: string
}
export namespace Node {
  export type Id = string

  export interface Identifier {
    readonly nodeId: Node.Id
  }

  export const TYPES = [
    { label: 'Default', value: 'default' },
    { label: 'Future', value: 'future' },
    { label: 'Temporary', value: 'temporary' },
  ] as const satisfies readonly ds.input.select.models.Item<Node['type']>[]
}
